import { useContext, useMemo } from 'react'
import { MQTTContext } from './mqtt.context'
import { useAppSelector } from '../../store/hooks'

export const useLocalMQTTClient = () => {
  const { client, isConnected } = useContext(MQTTContext)
  const { connected: isMSConnected } = useAppSelector(
    (state) => state.servers.connections.metricsServer
  )

  return useMemo(() => {
    if (isMSConnected && isConnected) {
      return client
    } else {
      return null
    }
  }, [client, isConnected, isMSConnected])
}
